import React, { useEffect } from 'react'
import { Redirect, useHistory, useLocation } from 'react-router-dom'
import Header from '../Component/Header'
import Footer from '../Component/footer'
import { canAccessManage, isLoggedIn } from './auth'
import { needsPasswordChange, changePasswordPath } from '../utils/sessionAuth'
import './Manage.css'

function ManageLayout({ children }) {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (!isLoggedIn()) {
      history.replace('/Login')
      return
    }
    if (needsPasswordChange()) {
      history.replace(changePasswordPath('/manage'))
      return
    }
    if (!canAccessManage()) {
      history.replace('/')
    }
  }, [history, location.pathname])

  if (!isLoggedIn()) {
    return <Redirect to="/Login" />
  }
  if (needsPasswordChange()) {
    return <Redirect to={changePasswordPath('/manage')} />
  }
  if (!canAccessManage()) {
    return <Redirect to="/" />
  }

  return (
    <div className="manage-shell">
      <Header />
      <div className="container-fluid manage-body">
        <main className="manage-main py-3">{children}</main>
      </div>
      <Footer />
    </div>
  )
}

export default ManageLayout
